import { render, staticRenderFns } from "./CategoriesTab.vue?vue&type=template&id=e28967f6"
import script from "./CategoriesTab.vue?vue&type=script&lang=js"
export * from "./CategoriesTab.vue?vue&type=script&lang=js"
import style0 from "./CategoriesTab.vue?vue&type=style&index=0&id=e28967f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports